import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as InfoIcon } from '@pkg/assets/icons/v2/info.svg';
import { Popover } from '@pkg/components';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { updateNFTManagerFilters } from '@app/store/actions/nft-manager';
import { type RootState } from '@app/store/reducers';

import { Label, Wrapper } from './styles';

export function Unsupported() {
    const { t: translate } = useTranslation(['yat_nft_manager']);
    const dispatch = useAppDispatch();
    const unsupportedCount = useAppSelector((state) => state.nftManager.unsupportedNfts?.length);
    const unsupported = useAppSelector((state: RootState) => state.nftManager.managerFilters.unsupported);
    const editingLiquidID = useAppSelector((state: RootState) => state.yatPage.editStates.editingLiquidID);
    const toggleUnsupported = () => {
        const filter = { unsupported: !unsupported };
        dispatch(updateNFTManagerFilters({ filter }));
    };
    if (!editingLiquidID || unsupported || !unsupportedCount || unsupportedCount === 0) return null;
    return (
        <Wrapper>
            <Popover
                placement="bottom"
                trigger={<InfoIcon />}
                alignment="center"
                variant="primary"
                action={toggleUnsupported}
                actionContent={translate('unsupported_nft_not_show_anyway')}
            >
                {translate('unsupported_nft_not_shown_tooltip')}
            </Popover>
            <Label>{translate('unsupported_nft_not_shown', { unsupportedCount })}</Label>
        </Wrapper>
    );
}
